import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import RouteNotFound from '../../RouteNotFound';
import NarrativeReportsViews from './NarrativeReportsViews';
import NarrativeReportPage from './NarrativeReportPage';

const NarrativeReportsHome = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={match.path}>
        <NarrativeReportsViews />
      </Route>
      <Route path={`${match.path}/:id/view`}>
        <NarrativeReportPage mode="view" />
      </Route>
      <Route path={`${match.path}/:id`}>
        <NarrativeReportPage />
      </Route>
      <Route path="*">
        <RouteNotFound />
      </Route>
    </Switch>
  );
};

export default NarrativeReportsHome;
